import { useQuery } from '@apollo/client';
import { useBrand } from '@bnnvara/brand';
import { Menu, MenuItem } from '@bnnvara/menu';
import React from 'react';

import { SubNavigationQuery } from '../../api/queries/menu.gql';
import useSharedRef from '../../hooks/useSharedRef';
import Link, { useLink } from '../Link';
import StyledSubNavigation from './styled';

const SubNavigation = () => {
  const brand = useBrand();
  const brandSlug = brand?.slug;
  const { isCurrent } = useLink();

  const { loading, data } = useQuery(SubNavigationQuery, {
    variables: {
      slug: brandSlug,
    },
  });

  const { createRef } = useSharedRef();
  const ref = createRef('subNavigation');

  if (data?.brand?.menuItems?.length > 0) {
    const menuItems = [...data?.brand?.menuItems].sort(
      (a, b) => a.order - b.order
    );
    return (
      <StyledSubNavigation ref={ref}>
        <Menu>
          {!loading &&
            menuItems.map(({ id, slug, body, order }, index) => {
              const isActive = isCurrent(slug);
              const gaLabel = `${index}-${body.replace(/\s/g, '-')}`;

              return (
                <MenuItem order={order} key={id} isActive={isActive}>
                  <Link
                    href={slug}
                    category="brandnavigatie"
                    action="click"
                    label={gaLabel}
                  >
                    {body}
                  </Link>
                </MenuItem>
              );
            })}
        </Menu>
      </StyledSubNavigation>
    );
  }

  return null;
};

export default SubNavigation;
